import {
    Checkbox,
    FormControlLabel,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField
} from '@material-ui/core'
import * as React from 'react'
import {LFWTestSection} from "../LFWSection";

type Q3Props = {
    section: LFWTestSection
    preview: boolean
}

type Q3State = {
    section: LFWTestSection
}


export class Q3 extends React.Component<Q3Props, Q3State> {
    state: Q3State = {
        section: this.props.section
    }

    public handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (this.state.section.response.hasOwnProperty(event.target.name)) {
            this.state.section.response[event.target.name] = event.target.checked
        }

        if (event.target.name == 'nie') {
            this.state.section.response['zez w oku']['lewym'] = false
            this.state.section.response['zez w oku']['prawym'] = false
            this.state.section.response['źrenice skierowane']['do środka'] = false
            this.state.section.response['źrenice skierowane']['na zewnątrz'] = false
            this.state.section.response['źrenice skierowane']['do góry'] = false
            this.state.section.response['oczopląs'] = false
            this.state.section.response['światłowstręt'] = false
            this.state.section.response['zapalenie oka, widoczne zaczerwienienie']['lewego'] = false
            this.state.section.response['zapalenie oka, widoczne zaczerwienienie']['prawego'] = false
        }

        if (event.target.name != 'nie') {
            this.state.section.response['nie'] = false
        }

        if (event.target.name == 'zez lewe oko') {
            this.state.section.response['zez w oku']['lewym'] = event.target.checked
        }

        if (event.target.name == 'zez prawe oko') {
            this.state.section.response['zez w oku']['prawym'] = event.target.checked
        }

        if (event.target.name == 'skierowane do środka') {
            this.state.section.response['źrenice skierowane']['do środka'] = event.target.checked
        }

        if (event.target.name == 'skierowane na zewnątrz') {
            this.state.section.response['źrenice skierowane']['na zewnątrz'] = event.target.checked
        }

        if (event.target.name == 'skierowane do góry') {
            this.state.section.response['źrenice skierowane']['do góry'] = event.target.checked
        }

        if (event.target.name == 'zapalenie lewego') {
            this.state.section.response['zapalenie oka, widoczne zaczerwienienie']['lewego'] = event.target.checked
        }

        if (event.target.name == 'zapalenie prawego') {
            this.state.section.response['zapalenie oka, widoczne zaczerwienienie']['prawego'] = event.target.checked
        }

        this.setState(prevState => {
            return {...prevState, section: this.state.section}
        })
    }

    public handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.state.section.response[event.target.name] = event.target.value;
        this.setState(prevState => {
            return {...prevState, section: this.state.section}
        })
    }

    public render = () => {
        return <TableContainer>
            <Table className={'gray-striped'}>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'nie'}
                                        checked={this.state.section.response.nie}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'nie'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'zez lewe oko'}
                                        checked={this.state.section.response['zez w oku']['lewym']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'zez, oko lewe'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'zez prawe oko'}
                                        checked={this.state.section.response['zez w oku']['prawym']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'zez, oko prawe'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'skierowane do środka'}
                                        checked={this.state.section.response['źrenice skierowane']['do środka']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'źrenice skierowane są do środka'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'skierowane na zewnątrz'}
                                        checked={this.state.section.response['źrenice skierowane']['na zewnątrz']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'źrenice skierowane są na zewnątrz'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'skierowane do góry'}
                                        checked={this.state.section.response['źrenice skierowane']['do góry']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'źrenice skierowane są do góry'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'oczopląs'}
                                        checked={this.state.section.response['oczopląs']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'oczopląs'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'światłowstręt'}
                                        checked={this.state.section.response['światłowstręt']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'światłowstręt'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'zapalenie lewego'}
                                        checked={this.state.section.response['zapalenie oka, widoczne zaczerwienienie']['lewego']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'zapalenie oka, widoczne zaczerwienienie oka lewego'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={'zapalenie prawego'}
                                        checked={this.state.section.response['zapalenie oka, widoczne zaczerwienienie']['prawego']}
                                        onChange={this.handleChange}
                                        disabled={this.props.preview}
                                        color="primary"
                                    />
                                }
                                label={'zapalenie oka, widoczne zaczerwienienie oka prawego'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Grid container direction="row"
                                  justify="flex-start"
                                  alignItems="center" spacing={3}>
                                <Grid item>
                                    inne
                                </Grid>
                                <Grid item sm>
                                    <TextField
                                        name="inne"
                                        variant="outlined"
                                        inputProps={{
                                            maxLength: 250,
                                        }}
                                        value={this.state.section.response['inne']}
                                        onChange={this.handleTextChange}
                                        multiline
                                        fullWidth
                                        disabled={this.props.preview}
                                    />
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    }
}